/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __extends } from "tslib";
import * as msRestAzure from "@azure/ms-rest-azure-js";
var packageName = "lab-services-internal";
var packageVersion = "1.0.0";
var LabsApiClientContext = /** @class */function (_super) {
  __extends(LabsApiClientContext, _super);
  /**
   * Initializes a new instance of the LabsApiClient class.
   * @param credentials Credentials needed for the client to connect to Azure.
   * @param subscriptionId The ID of the target subscription.
   * @param [options] The parameter options
   */
  function LabsApiClientContext(credentials, subscriptionId, options) {
    var _this = this;
    if (credentials == undefined) {
      throw new Error('\'credentials\' cannot be null.');
    }
    if (subscriptionId == undefined) {
      throw new Error('\'subscriptionId\' cannot be null.');
    }
    if (!options) {
      options = {};
    }
    if (!options.userAgent) {
      var defaultUserAgent = msRestAzure.getDefaultUserAgentValue();
      options.userAgent = packageName + "/" + packageVersion + " " + defaultUserAgent;
    }
    _this = _super.call(this, credentials, options) || this;
    _this.apiVersion = '2023-02-01';
    _this.acceptLanguage = 'en-US';
    _this.longRunningOperationRetryTimeout = 30;
    _this.baseUri = options.baseUri || _this.baseUri || "https://labs.azure.com";
    _this.requestContentType = "application/json; charset=utf-8";
    _this.credentials = credentials;
    _this.subscriptionId = subscriptionId;
    if (options.acceptLanguage !== null && options.acceptLanguage !== undefined) {
      _this.acceptLanguage = options.acceptLanguage;
    }
    if (options.longRunningOperationRetryTimeout !== null && options.longRunningOperationRetryTimeout !== undefined) {
      _this.longRunningOperationRetryTimeout = options.longRunningOperationRetryTimeout;
    }
    return _this;
  }
  return LabsApiClientContext;
}(msRestAzure.AzureServiceClient);
export { LabsApiClientContext };